export default "__VITE_ASSET__CsdzMvrM__"